import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { LocaleUtil, ServerDate } from "@eres/core";
import { LVStrings } from "@my-dld/assets/strings";

export interface GreenListStatus {
	ParticipantId: number | undefined;
	NameAr: string | undefined;
	NameEn: string | undefined;
	Mobile: string | undefined;
	Email: string | undefined;
	Notes: string | undefined;
	ExpiryDate: ServerDate;
	IsActive: boolean;
	TotalRowsCount: number;
	ServiceTypes?: SubscriptionService[];
}

export interface GreenListOTP {
	Email?: string;
	Mobile?: string;
}

export interface GreenListVerifyOTP {
	otp: string;
}

export interface VerifyEmailOTP extends GreenListVerifyOTP {
	Email: string;
}

export interface VerifyMobileOTP extends GreenListVerifyOTP {
	Mobile: string;
}

export enum SubscriptionServiceId {
	ALL = 1,
	SELL = 2,
	BUY = 3,
	LEASE = 4,
}

interface GPropertyType {
	PropertyTypeId: number;
	PropertyTypeNameAr?: string;
	PropertyTypeNameEn?: string;
}

interface GArea {
	AreaId: number;
	AreaNameAr?: string;
	AreaNameEn?: string;
}

export interface SubscriptionService {
	ServiceTypeId: SubscriptionServiceId;
	ServiceTypeNameAr?: string;
	ServiceTypeNameEn?: string;
	PropertyTypes?: GPropertyType[];
	Areas?: GArea[];
	FromValue?: number;
	ToValue?: number;
}

export interface Lookup extends LocaleValue {
	Id: number;
}

export enum Lookups {
	AREAS = 8,
}

export const PropertyTypesItems: Lookup[] = [
	{
		Id: 3,
		...LVStrings.unit,
	}, {
		Id: 4,
		...LVStrings.villa,
	}, {
		Id: 2,
		...LVStrings.building,
	}, {
		Id: 1,
		...LVStrings.land,
	},
];

export const SubscriptionAll: SubscriptionService = {
	ServiceTypeId: SubscriptionServiceId.ALL,
	ServiceTypeNameAr: LVStrings.gl_all_services.ar,
	ServiceTypeNameEn: LVStrings.gl_all_services.en,
};
export const AllSubscriptions: SubscriptionService[] = [
	SubscriptionAll,
	{
		ServiceTypeId: SubscriptionServiceId.SELL,
		ServiceTypeNameAr: LVStrings.gl_sell_property.ar,
		ServiceTypeNameEn: LVStrings.gl_sell_property.en,
	},
	{
		ServiceTypeId: SubscriptionServiceId.BUY,
		ServiceTypeNameAr: LVStrings.gl_buy_property.ar,
		ServiceTypeNameEn: LVStrings.gl_buy_property.en,
	},
	{
		ServiceTypeId: SubscriptionServiceId.LEASE,
		ServiceTypeNameAr: LVStrings.gl_lease_property.ar,
		ServiceTypeNameEn: LVStrings.gl_lease_property.en,
	}
];

export function getServiceName( svc: SubscriptionService ) {
	return LocaleUtil.getLocalValue( {
		en: svc.ServiceTypeNameEn,
		ar: svc.ServiceTypeNameAr,
	} );
}

export function getGAreaName( area: GArea ) {
	return LocaleUtil.getLocalValue( {
		en: area.AreaNameEn,
		ar: area.AreaNameAr,
	} );
}

export function convertToGPropertyType( pt: Lookup ): GPropertyType {
	return {
		PropertyTypeId: pt.Id,
		PropertyTypeNameAr: pt.ar,
		PropertyTypeNameEn: pt.en,
	};
}

export function convertToGArea( pt: Lookup ): GArea {
	return {
		AreaId: pt.Id,
		AreaNameAr: pt.ar,
		AreaNameEn: pt.en,
	};
}

export interface VerifyRequest {
	Email?: string;
	Mobile?: string;
	otp: string;
}

export function sortAreaAndUpdateServices( serviceTypes: SubscriptionService[] ): SubscriptionService[] {
	if ( serviceTypes ) {
		return serviceTypes.filter( value => {
			return {
				...value,
				Areas: value.Areas ? sortAreas( value.Areas ) : [],
			};
		} );
	}
	return serviceTypes;
}

function sortAreas( areas: GArea[] ): GArea[] {
	if ( areas.length > 0 ) {
		let sorter = ( a: GArea, b: GArea ) => {
			let aName = LocaleUtil.getLocalValue( { en: a.AreaNameEn, ar: a.AreaNameAr } );
			let bName = LocaleUtil.getLocalValue( { en: b.AreaNameEn, ar: b.AreaNameAr } );
			aName = aName ? aName.toLowerCase().trim() : "";
			bName = bName ? bName.toLowerCase().trim() : "";
			return aName.localeCompare( bName );
		};
		return areas.sort( sorter );
	}
	return areas;
}
